const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  ps: state => state.user.ps,
  user_id: state => state.user.user_id,
  button_permissions: state => state.user.button_permissions, // 按钮权限
  toolConfig: state => state.user.toolConfig, // 缓存工具配置
  getToken: state => state.user.getToken,
  user: state => state.user, // 用户
  userInfo: state => state.user.user, // 用户详情
  companyName: state => state.user.companyName // 当前人员的所在公司
}
export default getters
